/** Sort options for the redesigned portfolio filter (independent of legacy SortTypes). */
export const PORTFOLIO_SORT = {
	oblast: "oblast",
	name: "name",
	value: "value",
	producer: "producer",
} as const;

export type PortfolioSortKey =
	(typeof PORTFOLIO_SORT)[keyof typeof PORTFOLIO_SORT];
